import { uiStore } from 'shared/store/uiStore'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'

type IOpenProfileSearch = {
  contactId: number
}

export const openProfileSearch = (params: IOpenProfileSearch) => {
  const query = new URLSearchParams()

  if (params.contactId) {
    query.set('contactId', String(params.contactId))
  }

  uiStore.changeRoute({
    path: `/${ConversationsPath.searchProfile}`,
    query: query.toString(),
  })
}
